module.exports = __webpack_public_path__ + "media/images/covid/newmainImg_mobile-cf606630ffd61bd2c5a4e463bd52748d.jpg";